import del from './delete';
import get from './get';
import provisioning from './provisioning';
import put from './put';

export default { del, get, put, provisioning };
